<template>
  <div>
    <h2>Yay, you are now Pro!</h2>
    <p>veri niice..</p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ProCongrats',
  setup() {
    return { }
  }
})
</script>

<style>

</style>